import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './cargo-model';
import { VehicleSide } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import DoorImg from '../../assets/images/cargo-model/door.png';
import DoorWindowImg from '../../assets/images/cargo-model/door_window.png';

interface Props extends VehicleModelProps {
  side: VehicleSide;
}

const DOOR_STYLES = {
  [VehicleSide.Left]: 0,
  [VehicleSide.Right]: 180,
};

class VehicleDoor extends React.Component<Props, any> {
  getVehicleItem = () => {
    const { side } = this.props;
    return `${side}-door`;
  };

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <div className={className} onClick={this.clickHandler}>
        <VehicleStateImg
          className={`vehicle-door ${vehicleState[vehicleItem]}`}
          src={DoorImg}
        />
        <VehicleStateImg
          className={`vehicle-door-window ${vehicleState[vehicleItem]}`}
          src={DoorWindowImg}
        />
      </div>
    );
  }
}

const StyledVehicleDoor = styled(VehicleDoor)`
  position: relative;
  top: -5.5em;
  transform: rotateY(${({ side }) => DOOR_STYLES[side]}deg);

  .vehicle-door {
    width: 5em;
  }

  .vehicle-door-window {
    position: absolute;
    z-index: -1;
    width: 2em;
    left: 2.7em;
    top: 0.5em;
  }
`;

export default StyledVehicleDoor;
